
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaiertigacabs() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Ertiga Cabs ',
        heading: 'Skyline Cabs: Pune to Mumbai Ertiga Cabs',
        headingDescription: 'Skyline Cabs offers spacious and reliable Pune to Mumbai Ertiga Cabs for a comfortable group journey. Whether you are traveling with family, friends, or colleagues, our Ertiga cabs provide ample space, smooth rides, and excellent fuel efficiency. With experienced drivers, well-maintained vehicles, and affordable rates, we ensure a hassle-free travel experience from Pune to Mumbai. Book your Ertiga cab today with Skyline Cabs and enjoy a safe and convenient trip with plenty of room to relax.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Ertiga Per KM Rate in Pune",
      "description": "Skyline Cabs offers transparent and competitive per kilometer pricing for Ertiga cabs in Pune. Ideal for both local travel and long-distance trips like Pune to Mumbai, our Ertiga per km rates are budget-friendly, making it a top choice for families and small groups."
    },
    {
      "name": "Pune to Mumbai Airport Ertiga Cab",
      "description": "Book your comfortable Pune to Mumbai Airport ride with Skyline Cabs in an Ertiga. Enjoy smooth airport transfers with ample luggage space, experienced drivers, and timely pickups from anywhere in Pune, including Viman Nagar, Kharadi, or Wagholi."
    },
    {
      "name": "Pune to Dadar Ertiga Cab Fare",
      "description": "Skyline Cabs provides affordable and convenient Ertiga cab services from Pune to Dadar. With spacious seating and courteous drivers, our fares are tailored for one-way or round-trip travel, ensuring a reliable experience."
    },
    {
      "name": "Pune to Andheri Ertiga Taxi Fare",
      "description": "Travel comfortably from Pune to Andheri in a 7-seater Ertiga cab by Skyline Cabs. Our pricing is competitive, with flexible pick-up points, including Wagholi, Kharadi, Viman Nagar, and Kothrud. Ideal for family travel or airport drops."
    },
    {
      "name": "Pune to Mumbai One Way Ertiga Taxi Cab",
      "description": "Skyline Cabs offers one-way Ertiga cab service from Pune to Mumbai at pocket-friendly fares. Perfect for airport transfers or business trips, our clean and comfortable Ertigas are driven by professionals ensuring timely and safe travel."
    },
    {
      "name": "Ertiga Cab in Pune",
      "description": "Looking for an Ertiga cab in Pune? Skyline Cabs has you covered with on-demand and advance bookings for local or outstation rides. Our vehicles are ideal for up to 6 passengers and luggage, suitable for family, leisure, or corporate travel."
    },
    {
      "name": "Ertiga Cab for Mumbai Airport Drop",
      "description": "Get a reliable Mumbai Airport drop from Pune in a spacious Ertiga with Skyline Cabs. We offer 24/7 service, competitive fares, and safe driving to ensure you reach the airport comfortably and on time, even during early morning or late night hours."
    },
    {
      "name": "Viman Nagar to Mumbai Cabs",
      "description": "Skyline Cabs provides quick and comfortable cab services from Viman Nagar to Mumbai. Book an Ertiga, Innova, or Sedan for airport transfers, business travel, or sightseeing, with doorstep pickup and transparent fares."
    },
    {
      "name": "Wagholi to Mumbai Cab Service",
      "description": "Travel from Wagholi to Mumbai seamlessly with Skyline Cabs' reliable Ertiga and SUV fleet. Perfect for one-way drops, airport transfers, or outstation visits, we ensure a smooth ride with experienced drivers and well-maintained cars."
    },
    {
      "name": "Pune to Borivali Ertiga Cab",
      "description": "Need to get from Pune to Borivali? Skyline Cabs offers comfortable and affordable Ertiga cabs for one-way or round trip journeys. Enjoy a smooth ride with spacious seating, air-conditioning, and punctual service."
    },
    {
      "name": "Pune to Andheri Ertiga Cab",
      "description": "Book an Ertiga cab from Pune to Andheri with Skyline Cabs for a reliable travel experience. Our clean vehicles and professional drivers ensure a stress-free journey, whether you're heading to a business meeting or catching a flight."
    },
    {
      "name": "Pune to Dadar Ertiga Cab",
      "description": "Skyline Cabs provides timely and comfortable Ertiga cab service from Pune to Dadar. With ample luggage space and affordable fares, this 7-seater option is great for family or group travel to central Mumbai destinations."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Skyline Cabs offers 7-seater Ertiga cabs for Pune to Mumbai journeys. Our cabs are perfect for small groups, with spacious interiors, friendly drivers, and competitive pricing for one-way or round trips."
    },
    {
      "name": "Pune to Mumbai 7 Seater Cab",
      "description": "Travel with comfort in a 7-seater Ertiga or Innova cab from Pune to Mumbai with Skyline Cabs. Ideal for families and groups, we offer clean cars, courteous drivers, and flexible pickup times tailored to your schedule."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Skyline Cabs provides Pune to Mumbai round trip cab services at affordable rates. Book a spacious Ertiga or premium Innova Crysta for a full-day or two-way travel, with round-the-clock availability and professional service."
    },
    {
      "name": "Pune to Mumbai Airport Ertiga Cab",
      "description": "Choose Skyline Cabs for your Pune to Mumbai Airport drop in a 7-seater Ertiga. Ideal for families or group travelers, we offer door-to-door pickup, safe driving, and reasonable rates with no hidden charges."
    },
    {
      "name": "Pune to Mumbai Central Cab",
      "description": "Skyline Cabs offers reliable cab service from Pune to Mumbai Central with flexible vehicle options including Ertiga and Innova. Get picked up from your doorstep and enjoy a direct, comfortable ride to the city center."
    },
    {
      "name": "Ertiga on Rent in Pune",
      "description": "Rent an Ertiga in Pune with Skyline Cabs for local or outstation trips. Whether you're heading to Mumbai, Lonavala, or Mahabaleshwar, our Ertiga rentals offer space, comfort, and reliability at competitive rates."
    },
    {
      "name": "Pune to Mumbai Darshan Ertiga on Rent",
      "description": "Book an Ertiga on rent for a full-day Mumbai Darshan from Pune. Skyline Cabs provides guided travel packages with experienced drivers, comfortable vehicles, and curated itineraries to explore top attractions in Mumbai."
    },
    {
      "name": "Skyline Cabs Pune",
      "description": "Skyline Cabs is your trusted travel partner for all Pune to Mumbai routes. Specializing in Ertiga and Innova cabs, we offer 24/7 bookings, affordable fares, and professional service for airport transfers, outstation trips, and corporate travel."
    }
  ],
  "tableData": [
    ["Ertiga Per KM Rate in Pune", "Pune to Mumbai Airport Ertiga Cab"],
    ["Pune to Dadar Ertiga Cab Fare", "Pune to Andheri Ertiga Taxi Fare"],
    ["Pune to Mumbai One Way Ertiga Taxi Cab", "Ertiga Cab in Pune"],
    ["Ertiga Cab for Mumbai Airport Drop", "Viman Nagar to Mumbai Cabs"],
    ["Wagholi to Mumbai Cab Service", "Pune to Borivali Ertiga Cab"],
    ["Pune to Andheri Ertiga Cab", "Pune to Dadar Ertiga Cab"],
    ["Pune to Mumbai Ertiga Cab", "Pune to Mumbai 7 Seater Cab"],
    ["Pune to Mumbai Cab Round Trip", "Pune to Mumbai Airport Ertiga Cab"],
    ["Pune to Mumbai Central Cab", "Ertiga on Rent in Pune"],
    ["Pune to Mumbai Darshan Ertiga on Rent", "Skyline Cabs Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Spacious and Comfortable Ertiga Rides",
        "WhyChoosedescription": "Skyline Cabs offers Ertiga cabs for your Pune to Mumbai journey, ideal for families and groups. With spacious seating for up to 6 passengers, generous legroom, and ample luggage space, the Ertiga makes long-distance travel both comfortable and convenient."
    },
    {
        "WhyChooseheading": "Perfect for Group and Family Travel",
        "WhyChoosedescription": "Whether you're heading to Mumbai with friends or family, the Ertiga is the perfect choice. Enjoy the convenience of traveling together in one vehicle, with enough space to accommodate everyone and their luggage without feeling cramped."
    },
    {
        "WhyChooseheading": "Well-Maintained and Clean Vehicles",
        "WhyChoosedescription": "Every Ertiga in our fleet is thoroughly cleaned and regularly serviced. You’ll enjoy a smooth and hygienic ride from Pune to Mumbai in a vehicle that’s not only comfortable but also maintained to the highest safety and quality standards."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Long-Distance Travel",
        "WhyChoosedescription": "Our professional drivers are experienced in intercity travel and well-acquainted with the Pune to Mumbai route. They ensure a safe, smooth, and pleasant ride in the Ertiga, handling traffic and road conditions with expertise and care."
    },
    {
        "WhyChooseheading": "Affordable Rates with Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive and transparent fares for Pune to Mumbai Ertiga cabs. With no hidden fees, you get great value for your money—ideal for group travel that doesn't compromise on comfort or quality."
    },
    {
        "WhyChooseheading": "24/7 Availability with Flexible Booking",
        "WhyChoosedescription": "Need to travel early morning or late at night? Our Pune to Mumbai Ertiga cab service is available 24/7. Book anytime through our app, website, or by phone, and we’ll be at your doorstep when you need us."
    },
    {
        "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
        "WhyChoosedescription": "Booking an Ertiga cab from Pune to Mumbai is quick and hassle-free. Use our easy-to-navigate website or mobile app for instant fare estimates, secure bookings, and real-time cab tracking for complete peace of mind."
    },
    {
        "WhyChooseheading": "Safe and Secure Journey Guaranteed",
        "WhyChoosedescription": "All Ertiga cabs are GPS-enabled, and our drivers undergo thorough background checks. Whether you're traveling with kids or elders, your safety is our top priority. Enjoy a worry-free journey from Pune to Mumbai with Skyline Cabs."
    }
]














    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book an Ertiga cab from Pune to Mumbai with Skyline Cabs?',
            answer:
                'Booking an Ertiga cab is simple through our website or mobile app. Select Pune as your pickup, Mumbai as your destination, and choose “Ertiga” under vehicle options. You can also book by calling our support team.',
        },
        {
            id: 2,
            question: 'Why choose an Ertiga for Pune to Mumbai travel?',
            answer:
                'The Ertiga is ideal for families and small groups. It offers ample legroom, luggage space, and a comfortable ride for long-distance travel. It’s the perfect mix of space and economy.',
        },
        {
            id: 3,
            question: 'Is the fare for Ertiga cabs fixed from Pune to Mumbai?',
            answer:
                'Yes, Skyline Cabs offers fixed and transparent pricing. The fare includes tolls, driver allowance, and taxes — with no hidden charges.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round trip in an Ertiga?',
            answer:
                'Yes, we provide both one-way and round-trip bookings in Ertiga cabs. Simply choose the option that suits your travel plan during booking.',
        },
        {
            id: 5,
            question: 'Is there enough luggage space in an Ertiga for a family?',
            answer:
                'Yes, the Ertiga is known for its spacious boot and roof storage (on request). It can easily handle luggage for up to 6 passengers.',
        },
        {
            id: 6,
            question: 'Are Ertiga cabs air-conditioned?',
            answer:
                'Absolutely! All our Ertiga vehicles are fully air-conditioned and maintained for optimal comfort.',
        },
        {
            id: 7,
            question: 'Can I pre-book an Ertiga cab in advance?',
            answer:
                'Yes, we recommend pre-booking Ertiga cabs for peak travel days or early morning journeys to ensure availability.',
        },
        {
            id: 8,
            question: 'Are your Ertiga cab drivers trained for intercity routes?',
            answer:
                'Yes, our drivers are experienced with Pune-Mumbai highway routes and prioritize safe, smooth, and punctual travel.',
        },
        {
            id: 9,
            question: 'Is Ertiga suitable for airport transfers to Mumbai?',
            answer:
                'Definitely. The Ertiga is a great choice for airport transfers, especially if you have multiple passengers and luggage. We ensure timely pickups and drop-offs.',
        },
        {
            id: 10,
            question: 'Why book Ertiga with Skyline Cabs?',
            answer:
                'Skyline Cabs offers clean, well-maintained Ertiga vehicles with trained drivers and honest pricing. It’s the perfect balance of comfort and cost-efficiency for your Pune to Mumbai journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rohit Sawant",
            rating: 5,
            review: "We booked an Ertiga for our Pune to Mumbai trip, and it was a great experience. The cab was spacious and clean, perfect for our family of five. The driver was polite and drove safely the whole way."
        },
        {
            name: "Miss. Rucha Nair",
            rating: 4,
            review: "I was traveling with friends, and the Ertiga from Skyline Cabs was a great choice. It had plenty of room for us and our bags. The ride was smooth and comfortable. Would love a built-in charging point next time!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Ertiga Cabs",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-ertiga-cab.jpg",
  "description": "Book Pune to Mumbai Ertiga cabs with Skyline Cabs for a spacious, comfortable, and family-friendly ride. Enjoy AC 6-seater travel with professional drivers — ideal for groups and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7680"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-ertiga-cabs"
  }
};


      
    
      

    return (
        <div>
  <Helmet>
  <title>Pune to Mumbai Ertiga Cabs | 6-Seater SUV Ride | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Ertiga cabs with Skyline Cabs for a spacious, comfortable, and family-friendly ride. Enjoy AC 6-seater travel with professional drivers — ideal for groups and long-distance journeys." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Ertiga Cabs, Ertiga Cab Booking Pune to Mumbai, 6-Seater Taxi Pune to Mumbai, SUV Cab Pune to Mumbai, Group Travel Cab Pune Mumbai, Family Cab Pune to Mumbai, AC Ertiga Cab Pune Mumbai, Pune Mumbai Ertiga Ride, Skyline Cabs Pune to Mumbai, One-Way Ertiga Taxi Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/19.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiertigacabs;